import { createTheme } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#211f31",
      orange: "#fd4f00",
      black: "#161616",
    },
    secondary: {
      main: "#F05A221A",
      darker: "#282828",
      orange: "#ff8956",
    },
    orange: {
      main: "#FF8956",
    },
    blue: {
      light: "#2C3C60",
    },
    gray: {
      main: "#868686",
      light: "#ECECEC",
    },
  },

  breakpoints: {
    values: {
      xxs: 0, // small phone
      xs: 300, // phone
      sm: 640, // tablets
      md: 915, // small laptop
      lg: 1200, // desktop
      xl: 1536, // large screens
    },
  },
  typography: {
    fontFamily:
      'gmarket, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
});

theme = createTheme(theme, {
  typography: {
    title: {
      fontSize: "2.8rem",
      fontWeight: "700",
      textAlign: "center",
      lineHeight: "4rem",
      [theme.breakpoints.down("md")]: {
        fontSize: "2rem",
        lineHeight: "3rem",
      },
    },
    subtitle: {
      fontSize: "1.8rem",
      fontWeight: "500",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.5rem",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.2rem",
      },
      fontFamily: "gmarket",
    },
    detail: {
      fontSize: "1.6rem",
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.4rem",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "1rem",
      },
      fontFamily: "gmarket",
    },
    h6: {
      fontSize: "1.3rem",
      // textAlign: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.2rem",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "1rem",
      },
    },
    h7: {
      fontSize: "1.1rem",
      // textAlign: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "0.9rem",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.8rem",
      },
    },
    body: {
      display: "block",
      fontSize: "16px",
      [theme.breakpoints.down("md")]: {
        fontSize: "14px",
      },
    },
    p: {
      display: "block",
      fontSize: "0.8rem",
      [theme.breakpoints.down("md")]: {
        fontSize: "0.7rem",
      },
    },
    small: {
      display: "block",
      fontSize: "0.7rem",
      [theme.breakpoints.down("md")]: {
        fontSize: "0.6rem",
      },
    },

    fontFamily: ["gmarket"].join(","),
  },
});

theme = createTheme(theme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily:
            'gmarket, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "&.highlight": {
            fontWeight: "bold",
            overflow: "hidden",
            width: "fit-content",
            whiteSpace: "initial",
            boxShadow: `inset 0 -1.1rem 0 ${theme.palette.secondary.orange}`,
            [theme.breakpoints.down("md")]: {
              boxShadow: `inset 0 -1.5rem 0 ${theme.palette.secondary.orange}`,
              height: "4rem",
            },
            [theme.breakpoints.down("sm")]: {
              fontSize: "1.5rem",
              height: "100%",
              boxShadow: `inset 0 -1.3rem 0 ${theme.palette.secondary.orange}`,
            },
          },
          "&.highlight-title": {
            fontWeight: "bold",
            overflow: "hidden",
            width: "fit-content",
            whiteSpace: "initial",
            height: "3rem",
            boxShadow: `inset 0 -1.3rem 0 ${theme.palette.secondary.orange}`,
            [theme.breakpoints.down("md")]: {
              boxShadow: `inset 0 -1.5rem 0 ${theme.palette.secondary.orange}`,
            },
            [theme.breakpoints.down("sm")]: {
              fontSize: "1.5rem",
              height: "100%",
              boxShadow: `inset 0 -1.3rem 0 ${theme.palette.secondary.orange}`,
            },
          },
        },
      },
    },
  },
});

export default theme;
